import axios from 'axios';
import { CONFIRM_EMPLOYEE } from './constants';

export function confirmEmployeeInvitation(data) {
  return axios
    .post(CONFIRM_EMPLOYEE, data, { withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}
